import PropTypes from 'prop-types';

import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import ErrorContainer from 'Containers/ErrorContainer';

import * as checkoutActions from 'dux/checkout/actions';
import * as checkoutCartSelectors from 'dux/checkoutCart/selectors';

import { useCheckoutCategory } from '../hooks/useCheckoutCategory';

const CheckoutErrorScene = ({ params }) => {
  const checkoutCategory = useCheckoutCategory();
  const dispatch = useDispatch();
  const error = useSelector(checkoutCartSelectors.getCartError);

  return (
    <ErrorContainer
      error={error}
      retry={() => dispatch(checkoutActions.loadCheckout(params, checkoutCategory))}
      sentryMessage="Invalid state on CheckoutContainer"
    />
  );
};

CheckoutErrorScene.propTypes = {
  params: PropTypes.shape({}).isRequired,
};

export default CheckoutErrorScene;
